'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');



const AnimationDurationMs=380;let

ToggleSidebarButtonDirective=function(_BaseControllerBacked){_inherits(ToggleSidebarButtonDirective,_BaseControllerBacked);function ToggleSidebarButtonDirective(){_classCallCheck(this,ToggleSidebarButtonDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ToggleSidebarButtonDirective,[{key:'textBindings',get:function()
{
return['collapsedClass','selector'];
}},{key:'template',get:function()

{
return'<div ng-click="controller.toggleSidebarVisibility()" class="toggle-groups-sidebar-button" ng-class="{collapsed: controller.isCollapsed}"></div>';
}},{key:'controller',get:function()

{
return ToggleSidebarButtonDirectiveController;
}}]);return ToggleSidebarButtonDirective}(BaseControllerBackedDirective);let


ToggleSidebarButtonDirectiveController=function(){_createClass(ToggleSidebarButtonDirectiveController,null,[{key:'$inject',get:function()
{
return['displaySettingsService','elementService','$rootScope','$timeout'];
}}]);

function ToggleSidebarButtonDirectiveController(displaySettingsService,elementService,$rootScope,$timeout){_classCallCheck(this,ToggleSidebarButtonDirectiveController);
this._displaySettingsService=displaySettingsService;
this._elementService=elementService;
this._$rootScope=$rootScope;
this._$timeout=$timeout;

this._updateSidebarVisibility(!1);
}ToggleSidebarButtonDirectiveController.prototype.

toggleSidebarVisibility=function toggleSidebarVisibility(){
this._displaySettingsService.toggleSidebarVisibility();

this._updateSidebarVisibility();
};ToggleSidebarButtonDirectiveController.prototype.

_updateSidebarVisibility=function _updateSidebarVisibility(){var _this2=this;let broadcastResize=arguments.length>0&&arguments[0]!==void 0?arguments[0]:!0;
if(!this._displaySettingsService.isLoaded){
return;
}

if(this._displaySettingsService.stickySettings.get('groupsSidebarVisible')){
this._elementService.removeClass(this.selector,this.collapsedClass);
this.isCollapsed=!1;
}else{
this._elementService.addClass(this.selector,this.collapsedClass);
this.isCollapsed=!0;
}

if(!broadcastResize){
return;
}

this._$timeout(function(){return _this2._$rootScope.$broadcast('resize::resize')},AnimationDurationMs);
};return ToggleSidebarButtonDirectiveController}();


module.exports=ToggleSidebarButtonDirective;
//# sourceMappingURL=toggleSidebarButtonDirective.js.map
